import { LockOutlined, MailOutlined } from '@ant-design/icons';
import { Button, Card, Form, Image, Input, message } from 'antd';
import React, { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { BE_HOST } from '../../config/config';
import axios from 'axios';
import Applogo from './../../assets/aapaNewlogoTm.png'
import newLogo from '../../assets/advant-logoTm.png'

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm();
  const location = useLocation()
  const [isLoading, setIsLoading] = useState(false)

  const [countdown, setCountdown] = useState(0);
  const [canResend, setCanResend] = useState(true);

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
      clearInterval(timer);
    }

    return () => clearInterval(timer);
  }, [countdown]);

  const startCountdown = () => {
    setCountdown(120); // 2 minutes = 120 seconds
    setCanResend(false);
  };

  const handleForgetPassword = async (value) => {
    console.log(value, "valueeeeee")
    console.log(value?.email, "    ", value?.password, "  ", value?.Confirm_password, "passwordsssss")
    setIsLoading(true)
    const payload = {
      email: value?.email,
      newPassword: value?.password,
      confirmPassword: value?.Confirm_password,
      url:BE_HOST
    };
    try {
      console.log(" Sending request...");
      const response = await axios.post(`${BE_HOST}/auth/forgot-password`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: "Bearer yourAccessToken"
          }
        }
      );
      console.log("Response:", response.data);
      message.success(response.data?.message)
      // navigate('/react-dashboard')
      // navigate('/Login', {
      //   state: { email: value?.email }
      // })
      startCountdown();
    } catch (error) {
      console.error(" Error:", error);
      message.error(error?.response?.data?.message)
    } finally {
      setIsLoading(false)
      console.log(" Cleanup or loading state reset here");
      // Example: setLoading(false);
    }
  }

  return (
    <>

      {/* <div className=" bg-[#000833] from-gray-50 to-gray-100 flex flex-col items-center justify-center p-4"> */}
      <div className="min-h-screen bg-[#000833] flex flex-col items-center justify-start pt-20 px-4">
      <div className='mb-2'>
        <Image
          style={{ marginTop: "6px" }}
          src={Applogo}
          alt="AAPA Logo"
          preview={false}
          className=" rounded-md"
          width={160}
          height={140}
        />
        </div>
        <div className="w-full max-w-[800px] flex flex-col items-center bg-[#000833] rounded-2xl
       border-[3px] border-white 
       ">
          <Image
            style={{ marginTop: "28px", marginBottom: "28px" }}
            src={newLogo}
            alt="AAPA Logo"
            preview={false}
            className="mb-8"
            width={300}
          // height={25}
          />
          <Card className="w-full max-w-[400px] shadow-lg rounded-lg overflow-hidden  bg-[#000833] mb-20">
            <div style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
              <span style={{ color: "#fff", textAlign: "center", fontWeight: "bold", fontSize: 17 }}>Forgot Password</span>
            </div>
            <Form
              form={form}
              onFinish={handleForgetPassword}
              layout="vertical"
              className="mt-4"
            >
              <Form.Item
                name="email"
                rules={[
                  { required: true, message: "Please enter your email" },
                  { type: "email", message: "Please enter a valid email" },
                ]}
              >
                <Input
                  prefix={<MailOutlined className="text-gray-400" />}
                  placeholder="Email Address"
                  size="large"
                  className="h-12"
                />
              </Form.Item>

              {/* <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please enter your password" },
              {
                validator: (_, value) => {
                  if (!value) return Promise.resolve();

                  if (value.length < 8) {
                    return Promise.reject("Password must be at least 8 characters");
                  }

                  if (!/[A-Z]/.test(value)) {
                    return Promise.reject("Password must include an uppercase letter");
                  }

                  if (!/\d/.test(value)) {
                    return Promise.reject("Password must include a number");
                  }

                  if (!/[^A-Za-z0-9]/.test(value)) {
                    return Promise.reject("Password must include a special character");
                  }

                  return Promise.resolve();
                },
              }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-gray-400" />}
              placeholder="Password"
              size="large"
              className="h-12"
            />
          </Form.Item>

          <Form.Item
            name="Confirm_password"
            dependencies={['password']} // 👈 Watch for changes in password field
            rules={[
              { required: true, message: "Please enter Confirm password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match'));
                },
              }),

            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="text-gray-400" />}
              placeholder="Confirm Password"
              size="large"
              className="h-12"
            />
          </Form.Item> */}

              <Form.Item>
                {!canResend ? (
                  <Button type="primary"  htmlType="submit" disabled block size="large" className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90">
                    Resend in {Math.floor(countdown / 60)}:{(countdown % 60).toString().padStart(2, '0')}
                  </Button>
                ) : (
                  <Button

                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    loading={isLoading}
                    className="h-12 bg-[#0EA5E9] hover:bg-[#0EA5E9]/90"
                  >
                    Reset Password
                  </Button>
                )}
              </Form.Item>
            </Form>
          </Card>
        </div>
        <style>
          {`
          .ant-message .ant-message-notice {
            padding: 16px 24px;
          }

          .ant-message .ant-message-notice-content {
            font-size: 24px;
            min-height: 50px;
            display: flex;
            align-items: center;
          }
        `}
        </style>
      </div>

    </>
  )
}

export default ForgotPassword
